import React from 'react';
import { Link } from 'react-router-dom';
import {
  UserIcon,
  BuildingOfficeIcon,
  ShieldCheckIcon,
  BellIcon,
} from '@heroicons/react/24/outline';

const settingsCards = [
  {
    title: 'Personal Information',
    description: 'Update your name, email, and profile details',
    href: '/settings/profile',
    icon: UserIcon,
  },
  {
    title: 'Memberships',
    description: 'View your organization and location memberships',
    href: '/settings/memberships',
    icon: BuildingOfficeIcon,
  },
  {
    title: 'Security',
    description: 'Manage your password and security settings',
    href: '/settings/security',
    icon: ShieldCheckIcon,
  },
  {
    title: 'Notifications',
    description: 'Manage notifications on this device',
    href: '/settings/notifications',
    icon: BellIcon,
  },
];

const SettingsIndex: React.FC = () => {
  return (
    <div className="py-6">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Account Settings
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Manage your account information and preferences
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {settingsCards.map((card) => (
            <Link
              key={card.href}
              to={card.href}
              className="bg-white shadow rounded-lg p-6 hover:shadow-md transition-shadow border border-gray-200 hover:border-primary-300"
            >
              <card.icon className="h-8 w-8 text-primary-500 mb-3" />
              <h3 className="text-base font-medium text-gray-900">{card.title}</h3>
              <p className="mt-1 text-sm text-gray-500">{card.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsIndex;
